var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{attrs:{"label":"ダウンロード","icon":"fas fa-download","outlined":"","running":_vm.isRunning},on:{"click":_vm.download}})}
var staticRenderFns = []

export { render, staticRenderFns }